import React from 'react'
import { Layout } from './Layout'
import { useProps, Params } from './useProps'

type Props = Params

export const ArcadeMachinesManagerPage = (props: Props) => {
  return <Layout {...useProps(props)} />
}
